import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  allBranchesLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.allBranchesLabel',
    description: 'Label for the all branches configuration',
    defaultMessage: 'All branches',
  },
  mainBranchLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.mainBranchLabel',
    description: 'Label for the main branch configuration',
    defaultMessage: 'Main branch',
  },
  unknownBranchLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.unknownBranchLabel',
    description: 'Label for the unknown branch configuration',
    defaultMessage: 'Unknown branch',
  },
  checkAriaLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.checkAriaLabel',
    description:
      'ARIA label for a merge check item, summarising the check result',
    defaultMessage: '{name}. {status}.{message}',
  },
  checkAriaLabelMessageSegment: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.checkAriaLabel',
    description:
      'Segment of the ARIA label for a merge check item that contains the check result message',
    defaultMessage: ' Message: {message}',
  },
  repositoryCheckLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.repositoryCheckLabel',
    description:
      'Label indicating a check was configured from repository settings',
    defaultMessage: 'From repository settings',
  },
  projectCheckLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.projectCheckLabel',
    description:
      'Label indicating a check was configured from project settings',
    defaultMessage: 'From project settings',
  },
  workspaceCheckLabel: {
    id: 'frontbucket.repository.pullrequest.forgeMergeChecks.mergeCheckItem.workspaceCheckLabel',
    description:
      'Label indicating a check was configured from workspace settings',
    defaultMessage: 'From workspace settings',
  },
});
